import React from 'react';
import { Button } from '@core/js/components/common/Button';
import { useSmartTranslations } from '@core/js/hooks/i18n';
import uuid from 'uuid-random';
import style from './Popup.scss';

export const ActionButtons = ({ src = [], className: buttonsClassName = '' }) => {
    const t = useSmartTranslations();

    return (
        <div className={`popup-modal__buttons ${style.actionButtons} ${buttonsClassName}`}>
            {src.map(({ id = uuid(), onClick, className = '', text = '', view, color, variant, size }) =>
                <Button
                    key={id}
                    {...{ onClick, view, color, variant, size }}
                    className={`popup-modal__button ${style.actionButton} ${className}`}
                >
                    {t(text)}
                </Button>
            )}
        </div>
    );
};
